import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import FacebookRegular from './facebook-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <FacebookRegular {...validProps} />;
}
SvgComponent.iconName = 'facebookRegular';

export const FacebookRegularIcon = svgIconWrapper(SvgComponent);
